// extracted by mini-css-extract-plugin
module.exports = {"shoppingButton":"ShoppingBagButton_shoppingButton__J5gEL","backgroundWhite":"ShoppingBagButton_backgroundWhite__VWZGV"};